import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { useWindowWide } from '../../../../../../helpers/wideScreen';
import { color } from '../../../../../../styles/GlobalStyles';
import {
  Icon,
  IconArrowPolygon,
  IconSettingsCheckboxOff,
  IconSettingsCheckboxOn
} from '../../../../../../styles/Icons';
import { updateTeamCompletionSorting } from '../../../../myTeamBackOffice.actions';
import { DFButton, DefaultPlacement } from './DefaultPlacementButton.styles';

export const DefaultPlacementButton = () => {
  const { t } = useTranslation('myTeam');
  const dispatch = useAppDispatch();
  const { teamSettings } = useAppSelector((state) => state.settings);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAutoPlacementOption, setSelectedAutoPlacementOption] =
    useState<any>(teamSettings);

  const AutoPlacementOptions = [
    { value: 1, name: `${t('left_bottom')}` },
    { value: 2, name: `${t('right_bottom')}` },
    { value: 3, name: `${t('weaker_team')}` }
  ];

  useEffect(() => {
    if (teamSettings) {
      setSelectedAutoPlacementOption(AutoPlacementOptions[teamSettings - 1]);
    }
  }, [teamSettings]);

  const onSelectAutoPlacementOption = (value: number) => {
    dispatch(updateTeamCompletionSorting(value));
  };
  const wide = useWindowWide(800);

  return (
    <DFButton onClick={() => setIsModalOpen(!isModalOpen)}>
      {t('default_placement')}: {wide && <br />}{' '}
      <span>{selectedAutoPlacementOption?.name}</span>
      {!wide && (
        <Icon color={color.colors.primary900}>
          <IconArrowPolygon />
        </Icon>
      )}
      <DefaultPlacement open={isModalOpen}>
        {AutoPlacementOptions.map((apo, i) => {
          return (
            <div key={i} onClick={() => onSelectAutoPlacementOption(apo.value)}>
              {apo.name}

              <Icon mr='16' color={color.colors.primary900}>
                {selectedAutoPlacementOption?.value === apo.value ? (
                  <IconSettingsCheckboxOn size={'24'} />
                ) : (
                  <IconSettingsCheckboxOff size={'24'} />
                )}
              </Icon>
            </div>
          );
        })}
      </DefaultPlacement>
    </DFButton>
  );
};
